<template>
  <div class="versions">
    <van-nav-bar
      class="file-header nav-bar-bgcolor"
      :title="$t('file.revisions')"
      :left-text="$t('base.close')"
      @click-left="handleClose"
    />
    <ul>
      <li v-for="item of versions" :key="item.id">
        <version-item
          :item="item"
          @preview-version="handlePreviewVersion"
        />
      </li>
    </ul>
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'
import VersionItem from './VersionItem'

export default {
  name: 'VersionList',
  i18n,
  components: {
    VersionItem
  },
  props: {
    fileItem: Object,
    versions: Array
  },
  data () {
    return {}
  },
  watch: {
  },
  methods: {
    handleClose () {
      this.$emit('version-close')
    },
    handlePreviewVersion (file) {
      const {current, file_version_id} = file
      const {params, query} = this.$route
      const newQuery = {...query}
      // 关闭 versionList
      delete newQuery.tab

      if (current) {
        this.handleClose()
        return
      // eslint-disable-next-line eqeqeq
      } else if (query.version != file_version_id) {
        newQuery.version = file_version_id
      }
      this.$router.push({params, query: newQuery})
    }
  }
}
</script>
<style lang="postcss">
.versions {
  display: flex;
  height: 100%;
  flex-direction: column;

  & .file-header {
    flex: 0 0 auto
  }

  & ul {
    flex: 1 1 auto;
    padding-top: 18px;
    overflow: auto;

    & li {
      margin-bottom: 7px;
    }
  }
}
</style>
